import { Controller } from 'stimulus';

import { tableService } from '../libs/table_service';

export default class extends Controller {
  sortTable(event) {
    // Most likely the user does not hit the table cell with her click, so let's
    // fix this quickly (remember: <th><div><span></span></div></th>).
    let target =
      event.target.nodeName.toLowerCase() == 'span'
        ? event.target.parentElement.parentElement
        : event.target;

    tableService.sortTable(target.cellIndex);
    tableService.updateTableFreeze();
  }
}
